<template>
  <div style='position: relative;'>
    <div class='button-group' v-if='!isShown'>
      <a href='#' @click.prevent.stop='open' class='button button--secondary'><i class='fas fa-eye'></i>Reveal OTP</a>
    </div>
    <div class='otp' v-if='isShown && active'>
      <span v-if='!error' class='otp__value'>{{otp}}</span>
      <span v-if='error' class='otp__value danger'>ERROR</span>
      <div v-if='!error' class='progress' :style='{"width": `${countPercentage}%`}'></div>
      <nav v-if='!error'>
        <div style='display: inline-block'>
          <a href='#' v-if='!isCopied' @click.prevent.stop='copy($event)' class='button button--secondary'><i class='fas fa-copy'></i>Copy</a>
          <a href='#' v-if='isCopied' @click.prevent.stop='copy($event)' class='button button--secondary'>Copied!</a>
        </div>
      </nav>
    </div>
    <div class='otp' v-if='isShown && !active && !error'>
      <p class='otp__expired'>OTP expired</p>
      <nav>
        <div style='display: inline-block'>
          <a href='#' @click.prevent.stop='open' class='button button--secondary'><i class='fas fa-redo'></i>Refresh</a>
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
export default {
  props: ["url"],
  methods: {
    open () {
      var that = this;
      that.isShown = true;
      that.active = true;
      that.lookup()

      var countdown = setInterval(function() {
        that.count--;
        if (that.count <= 0) {
          //clearInterval(countdown);
          that.lookup()
          countdown
        }
      }, 1000);

      that.flash("Revealed!", 'success', 
        {
          timeout: 3000,
          important: true
        }
      );
    },
    lookup () {
      var that = this;

      that.$api.get(that.url)
      .then(function (response) {
        console.log(response.data)
        if (response.data["otp"]) {
          that.count = response.data["time_left"]
          that.otp = response.data["otp"];
        } else {
          that.error = true;
        }
      }).catch(function (error) {
        that.error = true;
      })
    },
    copy (e) {
      var that = this;
      that.setClipboard(that.otp, e)
    },
    setClipboard(value, e) {

      var that = this;

      Clipboard.copy(value);
      that.isCopied = true;

      that.flash("Copied!", 'success', 
        {
          timeout: 3000,
          important: true
        }
      );

      setTimeout(function(){ that.isCopied = false; }, 2000);
    }
  },
  computed: {
    countPercentage () {
      return ((1 - (this.count / 30)) * 100)
    }
  },
  data () {
    return {
      active: false,
      isShown: false,
      option: 6,
      otp: "",
      isCopied: false,
      count: 30,
      error: false
    }
  }
}

window.Clipboard = (function(window, document, navigator) {
    var textArea,
        copy;

    function isOS() {
        return navigator.userAgent.match(/ipad|iphone/i);
    }

    function createTextArea(text) {
        textArea = document.createElement('textArea');
        textArea.value = text;
        document.body.appendChild(textArea);
    }

    function selectText() {
        var range,
            selection;

        if (isOS()) {
            range = document.createRange();
            range.selectNodeContents(textArea);
            selection = window.getSelection();
            selection.removeAllRanges();
            selection.addRange(range);
            textArea.setSelectionRange(0, 999999);
        } else {
            textArea.select();
        }
    }

    function copyToClipboard() {        
        document.execCommand('copy');
        document.body.removeChild(textArea);
    }

    copy = function(text) {
        createTextArea(text);
        selectText();
        copyToClipboard();
    };

    return {
        copy: copy
    };
})(window, document, navigator);
</script>

